import { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { connect, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Col, Input, Row } from "reactstrap";
import swal from "sweetalert";
import { logout } from "../../../../store/actions/AuthActions";
import { api } from "../../../../utils/api";
import "../../../../css/permission.scss";
import { translate } from "../../../../utils/translate";

const AddAdmin = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const errorObj = { permission: '', access: '' };
    const [errors, setErrors] = useState(errorObj);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [formData, setFormData] = useState({
        permission: [],
        access: [],
        username: '',
        password: '',
        confirm_password: '',
        view_customer_hierarchy: []
    });

    useEffect(() => {
        getPermissionList();
    }, [props.auth.auth.access_token, props.lang]);

    const getPermissionList = () => {
        fetch(api.get_permissions, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === "success") {
                    let arr = [];
                    responseJson.data.permission.map((item, i)=>{
                        Object.keys(item).map((data, j)=>{
                            item[data].map((s)=>{
                                arr.push(s.value)
                            })
                        })
                    })
                    let newFormData = {...formData};
                    newFormData.permission = arr;
                    newFormData.access = ['/system/change-password'];
                    setFormData(newFormData)
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log('error', responseJson.message)
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };
        newFormData[fieldName] = fieldValue;
        setFormData(newFormData);
    }

    const submitForm = () => {
        let errorMsg = { ...errorObj };
        let check = true;
        let newFormData = { ...formData };
        if (!formData.username) {
            errorMsg.username = "This field is required.";
            check = false
        }
        if (!formData.password) {
            errorMsg.password = 'This field is required.';
            check = false;
        } else {
            if (formData.password.length < 6) {
                errorMsg.password = 'Password must at least 6 characters';
                check = false;
            }
        }

        if (!formData.confirm_password) {
            errorMsg.confirm_password = 'This field is required.';
            check = false;
        }

        if (formData.password && formData.confirm_password) {
            if (formData.password !== formData.confirm_password) {
                errorMsg.confirm_password = "Confirm password need to same with password";
                check = false;
            }
        }

        setErrors(errorMsg);
        if (check) {
            setLoading(true);
            fetch(api.add_admin, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang.toLowerCase(),
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
                body: JSON.stringify(newFormData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoading(false);
                    if (responseJson.status === 'success') {
                        swal(translate(props.lang, "Success"), responseJson.message, { icon: "success" });
                        history.push('/system/admin')
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        if (typeof responseJson.data.error === 'object') {
                            let apiErrorMsg = { ...errorObj };
                            let popupMessage = [];
                            Object.keys(responseJson.data.error).map((key, i) => {
                                apiErrorMsg[key] = responseJson.data.error[key];
                                popupMessage.push(responseJson.data.error[key])
                            })
                            setErrors(apiErrorMsg);
                            swal(translate(props.lang, "Error"), popupMessage.join("\n"), "error");
                        } else {
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                    }
                });
        }
    }


    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="d-flex align-items-center w-100 mb-4">
                            <Link to="/system/admin" className="cursor-pointer">
                                <div className="d-flex align-items-center">
                                    <img src={require('../../../../images/icon/backBtn.svg').default} className="img-fluid" alt="back" />
                                </div>
                            </Link>
                            <div className="ms-3">
                                <span className="infoTitle">{translate(props.lang, "Add New Admin")}</span>
                            </div>
                        </div>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="card-white px-md-5 px-2 py-4">
                            <Row className="px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-4">
                                    <div className='mb-2 text-start ps-2'>
                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Username")} </span>
                                    </div>
                                    <div className={`input-group-select py-1 py-md-0 ${errors.username ? 'errorBorder' : ''}`}>
                                        <Input
                                            type="text"
                                            name="username"
                                            placeholder={translate(props.lang, "Enter Username")}
                                            className={`input-transparent px-3`}
                                            autoComplete="off"
                                            value={formData.username}
                                            onChange={(e) => handleAddFormChange(e)}
                                        />
                                    </div>
                                    <div className="mt-1">
                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.username)}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-4">
                                    <div className='mb-2 text-start ps-2'>
                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Login Password")} </span>
                                    </div>
                                    <div className={`groupLabel-input ${errors.password ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                        <div className="input-group">
                                            <Input
                                                type={showPassword ? "text" : "password"}
                                                placeholder={translate(props.lang, "Enter Login Password")}
                                                className="form-control input-transparent py-1 px-3"
                                                onChange={e => handleAddFormChange(e)}
                                                name="password"
                                                value={formData.password}
                                            />
                                            <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowPassword(!showPassword)}>
                                                {showPassword ? (
                                                    <img src={require('../../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                ) : (
                                                    <img src={require('../../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.password)}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-4">
                                    <div className='mb-2 text-start ps-2'>
                                        <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Confirm Login Password")} </span>
                                    </div>
                                    <div className={`groupLabel-input ${errors.confirm_password ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                        <div className="input-group">
                                            <Input
                                                type={showConfirmPassword ? "text" : "password"}
                                                placeholder={translate(props.lang, "Confirm Login Password")}
                                                className="form-control input-transparent py-1 px-3"
                                                onChange={e => handleAddFormChange(e)}
                                                name="confirm_password"
                                                value={formData.confirm_password}
                                            />
                                            <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                                {showConfirmPassword ? (
                                                    <img src={require('../../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                ) : (
                                                    <img src={require('../../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.confirm_password)}</span>
                                    </div>
                                </Col>
                                
                                <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                    <Row className="px-0 mx-0">
                                        <Col lg={3} md={3} sm={6} xs={6} className="px-0">
                                            <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => submitForm()} disabled={loading}>
                                                {loading ? <FaSpinner className="fa-spin" /> : (
                                                    <span className={`btnText`}>{translate(props.lang, "Submit")}</span>
                                                )}
                                            </button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(AddAdmin);